
import { Link } from 'react-router-dom';

export default function TrackingHero() {
  return (
    <header className="relative min-h-[44vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f67d50513963b626025241e05f105fa3.jpg"
          alt="Suivez votre commande Daliah Secret"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/50 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <nav className="mb-8" aria-label="Breadcrumb">
          <ol className="flex items-center gap-2 text-sm text-white/70">
            <li>
              <Link
                to="/"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Accueil
              </Link>
            </li>
            <li>
              <i className="ri-arrow-right-s-line text-white/40"></i>
            </li>
            <li className="text-white">Suivi de commande</li>
          </ol>
        </nav>
        <p className="text-[#A5D6A7] text-sm tracking-[0.3em] mb-4 font-medium">
          SUIVI EN TEMPS RÉEL
        </p>
        <h1 className="text-5xl font-serif text-white mb-5 leading-tight">
          Suivez Votre Commande
        </h1>
        <p className="text-white/80 text-lg font-light max-w-xl leading-relaxed">
          Entrez votre numéro de commande ou votre adresse email pour suivre
          l&apos;état de votre commande Daliah Secret en temps réel.
        </p>
      </div>
    </header>
  );
}
